"use client";

import { usePathname, useRouter } from "next/navigation";
import Image from "next/image";

export default function LanguageSwitcher() {
  const router = useRouter();
  const pathname = usePathname();

  if (!pathname) return null;

  const isPT = pathname.startsWith("/pt");
  const isEN = pathname.startsWith("/en");

  const currentLocale = isPT ? "pt" : isEN ? "en" : "en";
  const newLocale = currentLocale === "pt" ? "en" : "pt";

  const pathWithoutLocale = pathname.replace(/^\/(pt|en)(\/|$)/, "/");
  const newPath = `/${newLocale}${pathWithoutLocale}`;

  const switchLocale = () => {
    router.push(newPath);
  };

  return (
    <button
      onClick={switchLocale}
      className="fixed bottom-6 right-6 bg-gradient-to-r from-[#D3DC7C] to-[#F0F4C3] text-[#1B475D] text-sm font-semibold px-4 py-2 rounded-full shadow-lg hover:bg-[#143746] transition flex items-center gap-2"
      aria-label="Switch language"
    >
      <Image
        src={currentLocale === "pt" ? "/images/flags/uk.png" : "/images/flags/br.png"}
        alt={currentLocale === "pt" ? "English" : "Português"}
        width={20}
        height={14}
        className="rounded-sm object-cover w-[20px] h-[14px] border"
      />
      {currentLocale === "pt" ? "EN" : "PT"}
    </button>
  );
}
